<template>
  <div class="container-hostess-center" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.HostessCenter.k008') }}</span>
        </template>
        <template v-if="chooseTab == 1" #right>
          <div v-if="agentProfile.avatar" class="target-avatar" @click="handleToAgentProfile">
            <img :src="agentProfile.avatar | imgPath" alt="" style="object-fit: cover" />
          </div>
        </template>
        <template v-else #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules01.png" alt="" @click="handleToRule" />
        </template>
      </van-nav-bar>
    </div>

    <div class="switch-tab">
      <div class="tab" :class="{ activeTab: chooseTab == 1 }" @click="changeTab(1)">{{ $t('lang.BaseCommon.k046') }}</div>
      <div class="tab" :class="{ activeTab: chooseTab == 2 }" @click="changeTab(2)">{{ $t('lang.HostessCenter.k013') }}</div>
    </div>

    <div v-if="chooseTab == 1">
      <MyLevel @hostessData="hostessData" @hostessIncome="hostessIncome" ref="childLevel" />
    </div>
    <div v-if="chooseTab == 2">
      <MyViolation />
    </div>

    <!-- 等级一样就显示我的等级 判断弹出时间 如果七天之内弹过就不需要弹了 -->
    <van-popup class="van-popup-box" v-model="showMyLevelDia" @close="showMyLevelDia == false" :lock-scroll="false" v-if="sevenTimeFlag">
      <div class="level-dia">
        <div class="level-dia-light">
          <img src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/bulibuli.png" alt="" />
        </div>
        <span class="tit">{{ $t('lang.BaseCommon.k046') }}</span>
        <div class="level-img">
          <div class="bg-img-box" :style="{ 'background-image': `url(${badgeStyle(curLevel)})` }"></div>
          <span class="level-num">{{ curLevel }}</span>
        </div>
        <span class="desc desc1">
          {{ $t('lang.HostessCenter.k003') }}
          <i style="color: #ffd64c">{{ $t('lang.BaseCommon.k002') }}.{{ curLevel }}</i>
        </span>
        <span class="desc">{{ $t('lang.HostessCenter.k025') }}</span>
        <div class="income">
          {{ myIncome }}
          <img :src="getMatchImg('beans')" alt="" />
          /{{ $t('lang.BaseCommon.k045') }}
        </div>
      </div>
      <div class="level-dia-btn" @click="setMyincome">{{ $t('lang.HostessCenter.k020') }}</div>
    </van-popup>

    <!-- 如果等级不一样就显示升级 -->
    <van-popup class="van-popup-box" v-model="showNewbieDia" @close="showNewbieDia == false" :lock-scroll="false">
      <div class="level-dia">
        <div class="level-dia-light">
          <img src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/bulibuli.png" alt="" />
        </div>
        <span class="tit">{{ $t('lang.HostessCenter.k014') }}</span>
        <div class="level-img">
          <div class="bg-img-box" :style="{ 'background-image': `url(${badgeStyle(curLevel)})` }"></div>
          <span class="level-num">{{ curLevel }}</span>
        </div>
        <span class="desc desc1 note-level">
          {{ $t('lang.HostessCenter.k026') }}
          <i style="color: #ffd64c">{{ $t('lang.BaseCommon.k002') }}.{{ curLevel }}</i>
        </span>
        <!-- 判断第一个%s==等级 第二个是%s==7 7天新手体验提现 -->
        <span class="desc">{{ handleTowText($t('lang.HostessCenter.k006'), '%s', curLevel, 7) }}</span>
        <div class="note">
          <span>{{ $t('lang.HostessCenter.k016') }}:</span>
          <div>
            {{ handleOneText($t('lang.HostessCenter.k015'), '%s', 7) }}
          </div>
        </div>
      </div>
      <div class="level-dia-btn" @click="showNewbieDia = false">{{ $t('lang.BaseCommon.k088') }}</div>
    </van-popup>

    <!-- 等级升级 -->
    <van-popup class="van-popup-box" v-model="showLevelUpDia" @close="showLevelUpDia == false" :lock-scroll="false">
      <div class="level-dia">
        <div class="level-dia-light">
          <img src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/bulibuli.png" alt="" />
        </div>
        <span class="tit">{{ $t('lang.BaseCommon.k018') }}</span>
        <div class="level-img">
          <div class="bg-img-box" :style="{ 'background-image': `url(${badgeStyle(curLevel)})` }"></div>
          <span class="level-num">{{ curLevel }}</span>
        </div>
        <span class="desc desc1">
          {{ $t('lang.HostessCenter.k002') }}
          <i style="color: #ffd64c">{{ $t('lang.BaseCommon.k002') }}.{{ curLevel }}</i>
        </span>
        <span class="desc">{{ $t('lang.HostessCenter.k018') }}</span>
        <div class="income">
          {{ myIncome }}
          <img :src="getMatchImg('beans')" alt="" />
          /{{ $t('lang.BaseCommon.k045') }}
        </div>
      </div>
      <div class="level-dia-btn" @click="showLevelUpDia = false">{{ $t('lang.HostessCenter.k007') }}</div>
    </van-popup>
  </div>
</template>

<script>
import { setStore, getStore } from '@/utils/storage'

import MyViolation from './components/MyViolation.vue'
import MyLevel from './components/Level.vue'
import { pageCssVars } from './z-style-cfg.js'

import levelOff from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png'
import levelOn from '@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_on.png'

export default {
  mixins: [pageCssVars],
  components: { MyLevel, MyViolation },
  data() {
    return {
      show: true,
      // 徽章背景图list
      levelBadgeList: {
        1: levelOff,
        2: levelOn,
        3: levelOn,
        4: levelOn,
      },
      showLevelUpDia: false, // 等级升级
      showMyLevelDia: false, // 我的等级
      showNewbieDia: false, // 新手特权
      chooseTab: 1,
      myIncome: 0,
      curLevel: 2,
      gradeFlag: false,
      // 取缓存的时间戳
      time: getStore('time') || 0,
      // 如果七天之内弹过就不需要弹了
      sevenTimeFlag: false,
      // agentProfile数据
      agentProfile: {
        ifShowContactPage: false,
        avatar: '',
      },
    }
  },
  methods: {
    // 时间 7天之内弹过就不需要弹了
    checkTimeFlag() {
      const nowTime = new Date().getTime() // 现在的时间
      if (getStore('time')) {
        // 判断现在的时间减去存的时间 如果小于7天就不显示了
        this.sevenTimeFlag = !(nowTime - getStore('time') < 7 * 24 * 60 * 60 * 1000)
        if (this.sevenTimeFlag) {
          setStore('time', nowTime)
        }
      } else {
        this.sevenTimeFlag = true
        setStore('time', nowTime)
      }
    },
    // 等级徽章
    badgeStyle(lv) {
      if (lv == 0) {
        return this.levelBadgeList[1]
      }
      if (lv > 0 && lv <= 3) {
        return this.levelBadgeList[2]
      }
      if (lv > 3 && lv <= 6) {
        return this.levelBadgeList[3]
      }
      if (lv > 6 && lv <= 10) {
        return this.levelBadgeList[4]
      }
    },
    changeTab(val) {
      this.chooseTab = val
    },
    // 接受子组建的值 主播设置的值
    hostessIncome(myIncome) {
      this.myIncome = myIncome
    },
    // 接受子组建的值
    hostessData(obj) {
      this.data = obj
      this.curLevel = obj.curGrade
      // 判断等级是否相同
      if (getStore('hostessGrade')) {
        // 相等且小于存的等级 就显示我的等级弹框
        if (obj.curGrade <= getStore('hostessGrade')) {
          this.gradeFlag = true
          this.showMyLevelDia = true
          this.showLevelUpDia = false
          this.showMyLevelDia = false
        } else {
          // 不相等且大于存的等级 就显示升级弹框 先判断是否是新手 如果是新手 优先显示新手特权弹窗  如果不是新手 就显示升级弹窗
          if (obj.remainNewerProviderTime && obj.remainNewerProviderTime > 0) {
            this.showNewbieDia = true
            this.showLevelUpDia = false
            this.showMyLevelDia = false
          } else {
            this.showNewbieDia = false
            this.showLevelUpDia = true
            this.showMyLevelDia = false
          }
          setStore('hostessGrade', obj.curGrade)
        }
      }
      // 无缓存等级
      else {
        if (obj.remainNewerProviderTime && obj.remainNewerProviderTime > 0) {
          this.showNewbieDia = true
          this.showLevelUpDia = false
          this.showMyLevelDia = false
        } else {
          this.showNewbieDia = false
          this.showLevelUpDia = false
          this.showMyLevelDia = true
        }
        setStore('hostessGrade', obj.curGrade)
      }

      // agentProfile
      this.agentProfile.ifShowContactPage = obj.ifShowContactPage
      this.agentProfile.avatar = obj.avatar
    },
    // set My income
    setMyincome() {
      this.showMyLevelDia = false
      this.$refs.childLevel.openPrivateDia()
    },
    // 跳转到规则页面
    handleToRule() {
      this.$router.push({ path: '/rules', query: { backType: 'previous' } })
    },
    // AgentProfile页面
    handleToAgentProfile() {
      if (this.agentProfile && this.agentProfile.ifShowContactPage) {
        this.$router.push({ path: '/agent-profile', query: { scene: '1' } })
      }
      //
      else {
        this.$client.showToast(this.$t('lang.HostessCenter.k027'))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-hostess-center {
  width: 100%;
  min-height: 100vh;
  background: #f5f5fa;
  padding: 0 0 30px 0;
  .custom-nav-block {
    background-color: #f5f5fa;

    .van-nav-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          > .target-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            box-sizing: border-box;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
  .switch-tab {
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 4px;
    border-radius: 17px;
    font-family: 'Inter-Regular';
    font-weight: 500;
    .tab {
      height: 26px;
      padding: 0 15px;
      color: rgba(51, 51, 51, 0.5);
      font-size: 16px;
      text-align: center;
      line-height: 26px;
    }
    .activeTab {
      position: relative;
      color: rgba(51, 51, 51, 1);
    }
    .activeTab::after {
      position: absolute;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      width: 29px;
      height: 3px;
      background: var(--theme-hostess-center-tab-underline, #925dff);
      border-radius: 2px;
    }
  }
  ::v-deep .van-popup {
    background-color: transparent;
  }
  .level-dia {
    position: relative;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Inter-Regular';
    color: #fff;
    font-size: 14px;

    .level-dia-light {
      width: 300px;
      height: 300px;
      position: absolute;
      overflow: hidden;
      z-index: 0;
      > img {
        width: 300px;
        height: 300px;
        animation: spin 4s linear infinite;
      }
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .tit {
      margin-top: 100px;
      height: 20px;
      font-weight: 600;
      font-size: 26px;
      color: #ffd64c;
      line-height: 20px;
    }
    .level-img {
      position: relative;
      width: 110px;
      height: 110px;
      margin: 10px 0 38px;
      font-weight: bold;
      font-size: 30px;
      line-height: 110px;
      text-align: center;
      line-height: 110px;
      .bg-img-box {
        width: 110px;
        height: 110px;
        background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png') no-repeat;
        background-size: 100% 100%;
      }
      .level-num {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
      }
    }
    .desc {
      display: block;
      text-align: center;
      line-height: 20px;
    }
    .desc1 {
      margin-bottom: 9px;
    }
    .note-level {
      font-size: 18px;
    }
    .note {
      margin-top: 20px;
      padding: 0 15px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      color: #ffffff;
      font-size: 11px;
      line-height: 20px;
    }
    .income {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #ffd64c;
      margin: 10px 0 40px;
      > img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .level-dia-btn {
    width: 175px;
    height: 40px;
    margin: 26px auto 0;
    line-height: 40px;
    text-align: center;
    background: var(--theme-level-dia-btn-bg, #a338fc);
    border-radius: 22px;
    font-family: 'Inter-Regular';
    font-weight: 500;
    font-size: 16px;
    color: var(--theme-level-dia-btn-color, #fff);
  }
  ::v-deep .van-popup-box {
    top: 40% !important;
    overflow: hidden;
  }
}
</style>
